import React from 'react';
import PropTypes from 'prop-types';
import { ArrowGoBack } from '@styled-icons/remix-line';
import { SkipBack } from '@styled-icons/remix-line';

import * as S from './styles';

const ButtonBack = ({ propLink, propText, propClickAction }) => {
  return (
    <S.Link onClick={propClickAction} to={propLink}>
      <S.IconWrapper>
        <SkipBack />
      </S.IconWrapper>
      {propText}
    </S.Link>
  );
};

ButtonBack.defaultProps = {
  propLink: '#',
  propText: '',
  propClickAction: () => {},
};

ButtonBack.propTypes = {
    propLink: PropTypes.string,
    propText: PropTypes.string,
    propClickAction: PropTypes.func,
};

export default ButtonBack;
